import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { GET_PALLETS } from "../../../../../../modules/API/settings";
import { getPallets } from "../../../../../../modules/requests/getPallets";
import { Orders } from "../../../../../../modules/API/Orders/orders";
import { Defaults } from "../../../../../../modules/API/Defaults/defaults";
import useWebSocket from "../../../../../../generic/hooks/useWebSocket";
import selectBrodMigdal from "../../../../../../generic/utils/selectBrodMigdal";
import { handleNotifications } from "../../../../../../generic/utils/handleNotifications";
import { LOAD, LOAD_END } from "../../../../../../../store/actions/actionsTypes";
import { RootState } from "../../../../../../../store/reducers/rootReducer";
import { IPalletTypeItem } from "../../../../../../modules/API/Defaults/models/pallets";
import { useBrodMigdalModal } from "../../../../../../generic/modals/BrodMigdalModal/BrodMigdalProvider";
import useDataFetcher from "../../../knisot/hooks/useFetchData";
import useConfig from "../../useConfig";
import { calcEndDay, getTranzitIDFromSessionStorage } from "../../helpers/likutListHelpers";
import { IOrderGoItem, TPathFunc } from "../../types/list";

const useLikutExpressList = () => {
    const [isAddIdToDesc] = useConfig()
    const localTranzitID = getTranzitIDFromSessionStorage()
    const dispatch = useDispatch()
    const controller = useRef(new AbortController());

    const getToken = useSelector((state: RootState) => state.mainReducer.token);
    const getRigths = useSelector((state: RootState) => state.mainReducer.user?.rights) ?? [];
    const defaults = useSelector((state: RootState) => state.defaults.defaults)
    const isAllowTopathWithActiveLikutStatus = selectBrodMigdal(defaults, 641, "Logical_Value")
    const checkFilterByWorkerRights = selectBrodMigdal(defaults, 410, "Logical_Value");
    const statusAzmanotToShow = useSelector((state: RootState) => state.defaults?.defaults?.filter((i: { Int_ID: number }) => i.Int_ID === 444)[0]);
    const isIgnoreDate = selectBrodMigdal(defaults, 634, "Logical_Value")

    const isNeedToSortByKav = selectBrodMigdal(defaults, 649, "Logical_Value")
    const isDev = getRigths.includes("DEV")
    const clientList = useSelector((state: RootState) => state.defaults.clientList);
    const idForWorker = useSelector((state: RootState) => state.mainReducer.user?.code_internal) ?? '';
    const { openModal } = useBrodMigdalModal();

    const [selectedDateStart, setSelectedDateStart] = useState<Date | string>(new Date())
    const [sortedByRamp, setSortedByRamp] = useState(false)

    const [tranzitID, setTranzitID] = useState(localTranzitID)
    // azmanot list
    const [azmanotList, setAzmanotList] = useState<IOrderGoItem[]>([])
    const [azmanotListDefault, setAzmanotListDefault] = useState<IOrderGoItem[]>([])
    const [azmanaNum, setAzmanaNum] = useState<number | null>(null)
    // pallets list
    const [palletList, setPalletList] = useState<IPalletTypeItem[]>([])
    const [palletListDefault, setPalletListDefault] = useState<IPalletTypeItem[]>([])

    const [inputAzmanotSearch, setInputAzmanotSearch] = useState('')

    const { socket, message } = useWebSocket('wss://my.agroline.co.il/ws/ws')

    const {
        data: warehouseList
    } = useDataFetcher(
        Defaults.getWarhouseList, "data"
    )

    useEffect(() => {
        let tempObj
        try {
            tempObj = JSON.parse(message)
        } catch {
            tempObj = null
        }
        if (!tempObj) return
        const found = azmanotListDefault.find(e => e.OrderID === tempObj?.OrderID)
        // check if need to filter by tranzit and if tranzit is not equal to current tranzit skip this order
        if (isNeedToSortByKav && tranzitID !== 0 && tranzitID !== tempObj?.WarehouseID) return
        if (found) {
            let tempArr = [...azmanotList]
            let tempArrDef = [...azmanotListDefault]
            if (tempObj.Status === -1) {
                const foundCurrent = azmanotList.find(e => e.OrderID === tempObj?.OrderID);
                let indexOfItemDef = azmanotListDefault.indexOf(found);
                tempArrDef.splice(indexOfItemDef, 1)
                if (foundCurrent) {
                    let indexOfItem = azmanotList.indexOf(foundCurrent);
                    tempArr.splice(indexOfItem, 1)
                }
            } else {
                tempArr = azmanotList.map(e => {
                    if (e.OrderID === tempObj?.OrderID) {
                        e = tempObj
                    }
                    return e
                })
                tempArrDef = azmanotListDefault.map(e => {
                    if (e.OrderID === tempObj?.OrderID) {
                        e = tempObj
                    }
                    return e
                })
            }
            setAzmanotList(tempArr)
            setAzmanotListDefault(tempArrDef)
        } else {
            let checkInput = tempObj.OrderID.toString().includes(inputAzmanotSearch) ||
                tempObj?.Customer_Name.toLowerCase().includes(inputAzmanotSearch.toLowerCase())
            if (!checkFilterByWorkerRights || !getRigths.includes("WORKER") || tempObj.WorkerID === +idForWorker) {
                if (checkInput) {
                    setAzmanotList([tempObj, ...azmanotList])
                }
                setAzmanotListDefault([tempObj, ...azmanotListDefault])
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message, socket])

    const sortByRamp = () => {
        if (!sortedByRamp) {
            const sorted = [...azmanotList].sort((a, b) => {
                return clientList?.hashTable[a.CustomerID]?.RampId - clientList?.hashTable[b.CustomerID]?.RampId
            })
            setAzmanotList(sorted)
            setSortedByRamp(true);
        } else {
            setAzmanotList(azmanotListDefault)
            setSortedByRamp(false);
        }
    }
    // set azmanot list before view
    useEffect(() => {

        if (selectedDateStart?.toString().length > 8) return

        const calcedDate = calcEndDay()
        const dateStart = isIgnoreDate ? "19200101" : selectedDateStart
        const dateEnd = isIgnoreDate ? "99991231" : calcedDate

        const fetchOrders = async () => {
            dispatch({ type: LOAD })
            try {
                const res = await Orders.getOrdersGo(`DateFrom=${dateStart}&DateTo=${dateEnd}`, tranzitID)

                if (isNeedToSortByKav) {
                    setAzmanotListDefault(res);
                    setAzmanotList(res);
                }
                else {
                    filterAzmanotByBrod(res)
                }
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error(err);
                }
            } finally {
                dispatch({ type: LOAD_END })
            }
        }
        fetchOrders()
        return () => {
            controller.current.abort("Component got unmounted");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDateStart, tranzitID])

    //set azmanot list for view

    const filterAzmanotByBrod = (state: IOrderGoItem[]) => {
        const filtered = state.filter(item =>
            (checkFilterByWorkerRights && getRigths.includes('WORKER') ? item.WorkerID === +idForWorker : true) &&
            (statusAzmanotToShow?.Text_Value?.trim() ? statusAzmanotToShow.Text_Value?.includes(item?.Status?.toString()) : true)
        );
        filtered.sort((a, b) => a.PickupOrder - b.PickupOrder)
        setAzmanotListDefault(filtered);
        setAzmanotList(filtered);
    }

    useEffect(() => {
        const fetchPallets = async () => {
            const palletController = await getPallets(getToken, GET_PALLETS, setPalletList, setPalletListDefault);
            return palletController;
        }

        const palletController = fetchPallets();

        return () => {
            controller.current.abort("Component got unmounted");
            if (palletController) {
                palletController.then(ctrl => {
                    if (ctrl) ctrl.abort("Component got unmounted");
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const searchAzmana = (input: string) => {
        const filtered = azmanotListDefault.filter(e => {
            return e.Customer_Name.toLowerCase().includes(input.toLowerCase())
                || e.OrderID.toString().includes(input.toLowerCase())
        })
        setInputAzmanotSearch(input);
        setAzmanotList(filtered);
    }

    const confirmSelectOrder = async (OrderType: number, OrderID: number, pathFunc: TPathFunc) => {
        if (checkFilterByWorkerRights) {
            pathFunc()
            return
        }
        const data = {
            "Status": 1,
            "WorkerID": +idForWorker || 0
        }
        try {
            await Orders.modifyOrder(OrderType, OrderID, data)
            pathFunc()
        } catch (err) {
            handleNotifications('קיימת הזמנה בסטטוס ליקוט', { type: 'warning' })
        } finally {

        }
    }
    const checkForActiveLikutAzmana = (Status: number, clientID: number, OrderType: number, OrderID: number, pathFunc: TPathFunc, WorkerID: number, TZSort: number) => {

        const isAllowStatusToMoveLikut = (Status === 0 || Status === 2 || Status === 5 || Status === 7)
        const isAllowToGet = (WorkerID === 0 || WorkerID === +idForWorker)

        if (
            getRigths.includes("ADMIN") ||
            getRigths.includes("OFFICE") ||
            getRigths.includes("DEV") ||
            isAllowTopathWithActiveLikutStatus
        ) {
            pathFunc()
            return
        }


        if (!isAllowToGet) {
            handleNotifications('הזמנה שיכת לעובד אחר', { type: 'warning' })
        }


        let check = azmanotListDefault.find(e => e.Status === 1 && e.WorkerID === +idForWorker);

        if (check) {

            if (!isAllowStatusToMoveLikut) {
                pathFunc()
            } else if (isAllowStatusToMoveLikut && check.CustomerID === clientID) {
                if (isNeedToSortByKav) {
                    if (TZSort === 0) {
                        confirmSelectOrder(OrderType, OrderID, pathFunc)
                    } else {

                        const findeOrderInPrevSort = azmanotListDefault.find(
                            order =>
                                (order.TZSort < TZSort)
                                && (order.Status === 0 || order.Status === 2 || order.Status === 5)
                        )

                        if (findeOrderInPrevSort) {
                            handleNotifications(` ${findeOrderInPrevSort.OrderID} יש הזמנה קודמת שלא סופקה`, { type: 'warning' })
                        } else {
                            confirmSelectOrder(OrderType, OrderID, pathFunc)
                        }
                    }
                } else {
                    confirmSelectOrder(OrderType, OrderID, pathFunc)
                }
            } else {
                handleNotifications('קיימת הזמנה בסטטוס ליקוט', { type: 'warning' })

            }
        } else {

            if (isAllowStatusToMoveLikut) {
                if (isNeedToSortByKav) {
                    if (TZSort === 0) {
                        confirmSelectOrder(OrderType, OrderID, pathFunc)
                    } else {

                        const findeOrderInPrevSort = azmanotListDefault.find(
                            order =>
                                (order.TZSort < TZSort)
                                && (order.Status === 0 || order.Status === 2 || order.Status === 5)
                        )

                        if (findeOrderInPrevSort) {
                            handleNotifications(` ${findeOrderInPrevSort.OrderID} יש הזמנה קודמת שלא סופקה`, { type: 'warning' })
                        } else {
                            confirmSelectOrder(OrderType, OrderID, pathFunc)
                        }
                    }
                } else {
                    confirmSelectOrder(OrderType, OrderID, pathFunc)
                }
            } else {
                pathFunc()
            }
        }
    }

    const handleSelectTransit = (id: number) => {
        // set to local storage selected value
        sessionStorage.setItem('selectedTransitLikut', id.toString())


        setTranzitID(id)

    }
    const handleFetchOrders = async () => {
        const calcedDate = calcEndDay()
        const dateStart = isIgnoreDate ? "19200101" : selectedDateStart
        const dateEnd = isIgnoreDate ? "99991231" : calcedDate
        const res = await Orders.getOrdersGo(`DateFrom=${dateStart}&DateTo=${dateEnd}`, tranzitID)
        if (isNeedToSortByKav) {
            setAzmanotListDefault(res);
            setAzmanotList(res);
        }
        else {
            filterAzmanotByBrod(res)
        }

    }

    const handleOpenDefaults = () => openModal([
        641,
        410,
        444,
        634,
        649
    ])

    return {
        azmanotList,
        inputAzmanotSearch,
        searchAzmana,
        sortedByRamp,
        sortByRamp,
        selectedDateStart,
        setSelectedDateStart,
        tranzitID,
        handleSelectTransit,
        warehouseList,
        azmanaNum,
        setAzmanaNum,
        palletList,
        checkForActiveLikutAzmana,
        handleFetchOrders,
        isNeedToSortByKav,
        isDev,
        isAddIdToDesc,
        clientList,
        handleOpenDefaults,
    }
}

export default useLikutExpressList;
